import { useState } from "react";
import { MdClose } from "react-icons/md";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import {
  ApprovePaymentFailed,
  MasterAdminLoader,
} from "../../../Redux/Action/MasterAdminAction";
import { X } from "lucide-react";

export const ViewPaymentFailedDetailsModel = ({
  setViewModal,
  userDetail,
  openviewModal,
}) => {
  const [paymentId, setPaymentId] = useState(null);
  const [isEditing, setIsEditing] = useState(true); // start with editing
  const [errorPaymentId, setErrorPaymentId] = useState(""); // start with editing

  const dispatch = useDispatch();

  const handleRefundRequest = () => {
    const data = {
      orderId: userDetail.orderId,
      paymentID: paymentId,
    };
    dispatch(ApprovePaymentFailed(data));
    dispatch(MasterAdminLoader());
    setViewModal(false);
  };

  const handelApproveRequest = async () => {
    if (!paymentId) {
      setErrorPaymentId("Please enter payment id");
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "You want to approve this request!",
      icon: "warning",
      iconColor: "#FCDD00",
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: "Yes, approve it!",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#FCDD00",
      cancelButtonColor: "#FFFCE1",
      customClass: {
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        handleRefundRequest();
      }
    });
  };

  return (
    <div
      className={`fixed right-0 top-0 h-full w-[500px] bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
        openviewModal ? "translate-x-0" : "translate-x-full"
      } flex flex-col`}
    >
      {/* Header */}
      <div className="flex items-center justify-between px-6 py-2 border-b border-gray-200 bg-[#FCDD00]">
        <div className="flex items-center">
          <h2 className="text-xl font-semibold text-gray-900 my-[7px]">
            Payment Details
          </h2>
        </div>
        <button
          onClick={() => setViewModal(false)}
          className="p-2 transition-colors duration-200 rounded-full hover:bg-white hover:bg-opacity-50"
        >
          <X className="w-5 h-5 text-gray-600" />
        </button>
      </div>

      {/* <hr className="mb-4" /> */}
      <div className="flex-1 p-6 space-y-6 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-400">
        {/* Payment Info */}
        <div className="space-y-4 text-sm text-gray-700">
          <div className="flex justify-between">
            <span className="font-medium text-gray-600">Plan Name:</span>
            <span className="text-gray-900 ">{userDetail.planName}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-medium text-gray-600">Qty:</span>
            <span className="text-gray-900 ">{userDetail.quentity}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-medium text-gray-600">Plan Price:</span>
            <span className="text-gray-900 ">₹{userDetail.PlanPrice}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-medium text-gray-600">Total Amount:</span>
            <span className="font-semibold text-gray-900">
              ₹{userDetail.amount}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="font-medium text-gray-600">Order ID:</span>
            <span className="text-gray-900">{userDetail.orderId}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-medium text-gray-600">Payment ID:</span>
            <span
              className={`${
                isEditing ? "cursor-pointer" : "cursor-not-allowed"
              }`}
            >
              <input
                type="text"
                onChange={(e) => {
                  if (isEditing) {
                    setPaymentId(e.target.value);
                  }
                }}
                required
                placeholder="Enter Payment ID"
                value={paymentId}
                disabled={!isEditing}
                className={` text-gray-900 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm rounded-md p-2`}
              />
              {errorPaymentId && (
                <p className="mt-1 text-xs text-red-500">{errorPaymentId}</p>
              )}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="font-medium text-gray-600">Invoice No:</span>
            <span className="text-gray-900">
              {userDetail.invoiceNo ? userDetail.invoiceNo : "-"}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="font-medium text-gray-600">Payment Source:</span>
            <span className="text-gray-900 capitalize">
              {userDetail.paymentSource}
            </span>
          </div>
        </div>
      </div>
      {/* Footer Actions */}
      <div className="flex flex-row gap-3 p-6 border-t border-gray-200 bg-gray-50">
        <button
          onClick={() => setViewModal(false)}
          className="flex items-center justify-center w-full px-4 py-3 font-medium text-gray-700 transition-colors duration-200 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
        >
          Close
        </button>
        <button
          onClick={() => handelApproveRequest()}
          className="w-full bg-[#FCDD00] text-[#1A1A1A] py-3 px-4 rounded-lg font-Poppins text-sm flex items-center justify-center gap-1 cursor-pointer  outline-none"
        >
          Approve
        </button>
      </div>
    </div>
  );
};
